import functions from "./functions";
import { jsPDF } from "jspdf";

let gameFrame, puzzleContainer, puzzleGame, puzzleImage;
let settings = {
    piece: 80,
    strokeWidth: 2,
    proximity: 30,
    lineSoftness: .25,
    size: {
        horizontal: 0,
        vertical: 0,
        count: 0
    }
};
let audio;
let frame;

let isPuzzleSolved = true,
    isFullscreen = false,
    totalMoves = 0,
    totalMistakes = 0;

function loadSettings() {

    switch (puzzleSettings.size) {
        case 30:
        case 28:
        case 24:
            settings.size.horizontal = 12;
            settings.size.vertical = 9;
            break;
        case 18:
        case 15:
        case 12:
            settings.size.horizontal = 8;
            settings.size.vertical = 6;
            break;
        case 10:
        case 7:
            settings.size.horizontal = 5;
            settings.size.vertical = 4;
            break;
        case 4:
        default:
            settings.size.horizontal = 4;
            settings.size.vertical = 3;
            break;
    }
    settings.size.count = puzzleSettings.size;

    audio = {
        completed: new Audio('/wp-content/themes/neve/dist/audio/tada.mp3'),
        wrong: new Audio('/wp-content/themes/neve/dist/audio/wrong.mp3'),
        valid: new Audio('/wp-content/themes/neve/dist/audio/ping.mp3'),
        drag: new Audio('/wp-content/themes/neve/dist/audio/connect.wav'),
        start: new Audio('/wp-content/themes/neve/dist/audio/start.mp3')
    };
}

function gameLoad(isStarted = false) {
    const initialWidth = window.innerWidth;
    puzzleImage = new Image();
    puzzleImage.src = puzzleSettings.baseImage;
    let puzzleGameContainer = document.querySelector('.game__puzzle-container');
    puzzleImage.onload = () => {
        let z = '';
        if (puzzleImage.naturalWidth <= puzzleImage.naturalHeight) {
            z = settings.size.horizontal;
            settings.size.horizontal = settings.size.vertical;
            settings.size.vertical = z;
        }
        let imageWidth = puzzleImage.naturalWidth,
            imageHeight = puzzleImage.naturalHeight;
        if (puzzleImage.naturalWidth > 800) {
            imageWidth = 700;
            imageHeight = imageWidth * (puzzleImage.naturalHeight / puzzleImage.naturalWidth);
        }

        if (imageHeight > (puzzleGameContainer.offsetHeight - 200)) {
            imageHeight =puzzleGameContainer.offsetHeight - 300;
            imageWidth = imageHeight * (  puzzleImage.naturalWidth /puzzleImage.naturalHeight);
        }

        if (puzzleImage) {
            puzzleGame = new headbreaker.Canvas('my-puzzle', {
                image: puzzleImage,
                width: puzzleGameContainer.offsetWidth,
                height: (puzzleGameContainer.offsetHeight - 100),
                pieceSize: {
                    x: (imageWidth) / settings.size.horizontal,
                    y: imageHeight / settings.size.vertical
                },
                proximity: settings.proximity,
                strokeWidth: settings.strokeWidth,
                outline: new headbreaker.outline.Rounded(),
                fixed: true,
                preventOffstageDrag: true,
                maxPiecesCount: {x: settings.size.horizontal, y: settings.size.vertical},
            });
            puzzleGame.refill();
            puzzleGame.adjustImagesToPuzzleHeight();
            puzzleGame.adjustImagesToPuzzleWidth();
            puzzleGame.autogenerate({
                horizontalPiecesCount: settings.size.horizontal,
                verticalPiecesCount: settings.size.vertical,
            });

            puzzleGame.onConnect((_piece, figure, _target, targetFigure) => {
                audio.drag.play();
                puzzleGame.redraw();
            });
            puzzleGame.onDisconnect(() => {
                audio.drag.play();
            });
            if (isStarted) {
                shuffleRandomPieces();
                puzzleGame.draw();
            }
            puzzleGame.attachSolvedValidator();
            puzzleGame.onValid(() => puzzleCompleted());
            puzzleGame.redraw();
        }
    };
}

function puzzleCompleted() {
    setTimeout(() => {
        audio.completed.play();
        isPuzzleSolved = true;
    }, 1500);
}

function gameRestart() {
    if (isPuzzleSolved) {
        gameStart();
    } else {
        puzzleGame.solve();
        isPuzzleSolved = true;
        gameStart();
    }
}

function gameStart() {
    $('.konvajs-content').remove();
    loadSettings();
    gameLoad(true);
    isPuzzleSolved = false;
    prepareCanvasToExport();
}

function initGame() {
    puzzleContainer = document.getElementById('my-puzzle');
    gameFrame = document.querySelector('.game__frame');
    if (puzzleContainer && gameFrame) {
        document.body.style.overflowY = 'hidden';
        loadSettings();
        loadUI();
        gameLoad();
        prepareCanvasToExport();
        document.querySelector('[data-generate-pdf]').addEventListener('click', canvasToImg);
    }
}

function loadUI() {
    let buttonFullscreen = document.querySelector('[data-toggle-fullscreen]'),
        buttonStart = document.querySelector('[data-puzzle-start]'),
        buttonRestart = document.querySelector('[data-puzzle-restart]'),
        buttonBack = document.querySelector('[data-backward]');

    if (buttonFullscreen) {
        buttonFullscreen.addEventListener('click', () => {
            if (isFullscreen) {
                document.exitFullscreen();
                isFullscreen = false;
            } else {
                gameFrame.requestFullscreen();
                isFullscreen = true;
            }
            $(buttonFullscreen).find('i').toggleClass('fa-close fa-expand');
        });

    }

    if (buttonStart) {
        buttonStart.addEventListener('click', () => {
            gameStart();
            buttonStart.classList.add('hide');
            buttonRestart.classList.remove('hide');
        });
    }

    if (buttonRestart) {
        buttonRestart.addEventListener('click', () => {
            gameRestart();
        });
    }

    if (buttonBack) {
        buttonBack.addEventListener('click', () => history.back());
    }

}

function shuffleRandomPieces() {
    functions.shuffleArray(puzzleGame.puzzle.pieces);
    let puzzleGameContainer = document.querySelector('.game__puzzle-container');

    for (let i = 0; i < settings.size.count; i++) {
        puzzleGame.puzzle.pieces[i].translate(
            functions.generateRandom(puzzleGameContainer.offsetWidth / 2, (puzzleGameContainer.offsetWidth / 2 + puzzleGameContainer.offsetWidth / 16) - 100),
            200 - functions.generateRandom(100, 200)
        );
    }
}

function prepareCanvasToExport(isStarted= false) {
    puzzleImage = new Image();
    puzzleImage.src = puzzleSettings.baseImage;
    let puzzleGameContainer = document.querySelector('.game__puzzle-container');
    puzzleImage.onload = () => {
        let z = '';
        if (puzzleImage.naturalWidth <= puzzleImage.naturalHeight) {
            z = settings.size.horizontal;
            settings.size.horizontal = settings.size.vertical;
            settings.size.vertical = z;
        }
        let imageWidth = puzzleImage.naturalWidth,
            imageHeight = puzzleImage.naturalHeight;
        if (puzzleImage.naturalWidth > 800) {
            imageWidth = 700;
            imageHeight = imageWidth * (puzzleImage.naturalHeight / puzzleImage.naturalWidth);
        }

        if (imageHeight > (puzzleGameContainer.offsetHeight)) {
            imageHeight =puzzleGameContainer.offsetHeight;
            imageWidth = imageHeight * (  puzzleImage.naturalWidth /puzzleImage.naturalHeight);
        }

        if (puzzleImage) {
            puzzleGame = new headbreaker.Canvas('newCanva', {
                image: puzzleImage,
                width: imageWidth + 100,
                height: imageHeight + 100,
                pieceSize: {
                    x: (imageWidth) / settings.size.horizontal,
                    y: imageHeight / settings.size.vertical
                },
                proximity:0,
                strokeWidth: settings.strokeWidth,
                outline: new headbreaker.outline.Rounded(),
                fixed: true,
                preventOffstageDrag: true,
                maxPiecesCount: {x: settings.size.horizontal, y: settings.size.vertical},
            });
            // puzzleGame.refill();
            puzzleGame.adjustImagesToPuzzleHeight();
            // puzzleGame.adjustImagesToPuzzleWidth();
            puzzleGame.autogenerate({
                horizontalPiecesCount: settings.size.horizontal,
                verticalPiecesCount: settings.size.vertical,
            });
            puzzleGame.redraw();
        }
    };
}

function canvasToImg() {
    let canvas = document.querySelector('#newCanva canvas');

    let url = canvas.toDataURL("image/png", 1.0);

    let newImgWrapper = document.createElement('div');
    newImgWrapper.classList.add('test3');
    document.body.appendChild(newImgWrapper); // add to end of your document
    let newImg = document.createElement("img"); // create img tag
    newImg.classList.add('test2');
    newImg.src = url;
    document.body.appendChild(newImg); // add to end of your document
    document.querySelector('.test3').appendChild(newImg);
    // var pxTomm = function(px){
    //     return Math.floor(px/($('#my_mm').height()/100)); //JQuery returns sizes in PX
    // };
    const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
    });
    let width = doc.internal.pageSize.getWidth();
    let ratio = canvas.height / canvas.width;

    doc.addImage(newImg, "PNG", -10, -10, width - 20 , (ratio * width) - 10);
    doc.save("puzzle.pdf");
}

export default {initGame};



// WEBPACK FOOTER //
// ./src/scripts/game-puzzle.js